<nav class="navbar navbar-expand-lg navbar-light bg-light d-print-none">
  <a class="navbar-brand" routerLink="/">TabLib</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item"><a class="nav-link" routerLink="chords" routerLinkActive="active">Chords</a></li>
      <li class="nav-item"><a class="nav-link" routerLink="chordsteps" routerLinkActive="active">ChordSteps</a></li>
      <li class="nav-item"><a class="nav-link" routerLink="songs" routerLinkActive="active">Songs</a></li>
    </ul>
  </div>
</nav>

<router-outlet></router-outlet>
